import React, { FC, useCallback } from 'react';
import classes from '../../asset/css/subscription-detail/product-info.module.css';
import NumberFormat from 'react-number-format';
import { RecommendProductInfoType } from '../../types/recommend-product-info-type';

export const RecommendProductInfo: FC<{
  active: boolean;
  productInfo: RecommendProductInfoType;
  loading: boolean;
  changeActiveFunc: (active: boolean, variantId: string, planId?: string, lineId?: string) => void;
}> = ({ active, productInfo, loading, changeActiveFunc }) => {
  // 切り替えボタンを押した時のイベント
  const changeActiveHandler = useCallback(() => {
    changeActiveFunc(active, productInfo.variantId, productInfo.planId);
  }, [active, changeActiveFunc, productInfo.planId, productInfo.variantId]);

  let priceHtml = (
    <div className={classes.mypage_subsc_item_price}>
      <div className={classes.mypage_subsc_item_price_org}>
        ￥<NumberFormat displayType="text" value={productInfo.originalPrice} thousandSeparator={true} /> →
      </div>
      <div className={classes.mypage_subsc_item_price_down}>
        ￥<NumberFormat displayType="text" value={productInfo.price} thousandSeparator={true} />
      </div>
    </div>
  );
  if (productInfo.originalPrice === productInfo.price) {
    priceHtml = (
      <div className={classes.mypage_subsc_item_price}>
        <div className={classes.mypage_subsc_item_price_down}>
          ￥<NumberFormat displayType="text" value={productInfo.price} thousandSeparator={true} />
        </div>
      </div>
    );
  }

  let recommendMessageHtml = <></>;
  if (productInfo.message !== '') {
    recommendMessageHtml = (
      <div className={classes.mypage_subsc_item_comment}>
        <p>{productInfo.message}</p>
      </div>
    );
  }

  return (
    <>
      <li>
        {recommendMessageHtml}
        <div className={classes.mypage_subsc_item_main}>
          <div className={classes.mypage_subsc_item_image}>
            <div style={productInfo.image ? { backgroundImage: `url('${productInfo.image}')` } : {}} />
          </div>
          <div className={classes.mypage_subsc_item_info}>
            <h5 className={classes.mypage_subsc_item_name}>{productInfo.productTitle}</h5>
            <div className={classes.mypage_subsc_item_option}>{productInfo.variantTitle}</div>
            {priceHtml}
          </div>
          <div className={classes.mypage_subsc_item_action}>
            <div className={classes.mypage_subsc_item_toggle_wrap}>
              <button
                className={
                  active ? `${classes.mypage_subsc_item_toggle} ${classes.active}` : classes.mypage_subsc_item_toggle
                }
                disabled={loading}
                onClick={changeActiveHandler}
              />
            </div>
            <div className={classes.mypage_subsc_item_adjust}>
              <button className={classes.mypage_subsc_item_plus} disabled={!active || loading}>
                −
              </button>
              <input type="text" className={classes.mypage_subsc_item_amount} value={productInfo.quantity} disabled />
              <button className={classes.mypage_subsc_item_minus} disabled={!active || loading}>
                ＋
              </button>
            </div>
          </div>
        </div>
      </li>
    </>
  );
};
